export default __webpack_public_path__ + "static/media/close.498cc732.svg";